/* eslint-disable @typescript-eslint/naming-convention */
import { StreamParser } from '../ai-stream-parser/StreamParser';
let openai = null;
function getOpenAiInstance(OpenAI) {
    let projectId = '';
    let env = 'dev';
    if (window?.RUNTIME_CONFIGS) {
        ({ projectId, env } = window.RUNTIME_CONFIGS);
    }
    else {
        const query = new URLSearchParams(window.location.search);
        projectId = query.get('projectId') || query.get('projectid') || '';
    }
    if (!projectId || !env)
        return;
    return new OpenAI({
        apiKey: '',
        baseURL: `${window.location.origin}/api/xy/llm`,
        dangerouslyAllowBrowser: true,
        defaultHeaders: {
            'xy-project-id': projectId,
            'xy-env': env,
        },
    });
}
/**
 * 异步加载 OpenAI 模块（优先从插件获取）
 */
async function initByImport() {
    const OpenAI = window?.OpenAI || (await import('openai')).default;
    window.OpenAI = OpenAI;
    openai = getOpenAiInstance(OpenAI);
}
/**
 * 同步加载 OpenAI 模块（只从插件获取）
 */
function initByPlugin() {
    const OpenAI = window?.OpenAI;
    if (OpenAI)
        openai = getOpenAiInstance(OpenAI);
}
export function getLLMInstance() {
    return new Proxy({}, {
        get(target, prop) {
            if (prop === 'init') {
                return () => initByImport();
            }
            if (prop === 'StreamParser') {
                return StreamParser;
            }
            if (!openai)
                initByPlugin();
            if (!openai)
                throw new Error('无极 AI 模块未加载，请在编辑端开启无极AI插件或者先执行 await w.ai.init() 进行模块初始化');
            return openai[prop];
        },
    });
}
